import React, { useEffect, useState } from "react";
import { useRouter } from "../../helper-functions/useRouterReplacement";
import { useSelector } from "react-redux";

const AuthGuard = (props) => {
  const { children, from } = props;
  const router = useRouter();
  const [checked, setChecked] = useState(false);
  const { configData } = useSelector((state) => state.configData);
  useEffect(
    () => {
      // Get query parameters from URL using React Router
      const pageParam = router.query?.page;

      const token = localStorage.getItem("token");
      const guest = localStorage.getItem("guest_id");

      // Determine route context
      const isBuyNowOrCampaign = pageParam === "buy_now" || pageParam === "campaign";
      const isCheckoutRoute = from === "checkout";

      // 1) Authenticated users always allowed
      if (token) {
        setChecked(true);
        return;
      }

      // 2) Checkout route should never force login for guests
      if (isCheckoutRoute) {
        setChecked(true);
        return;
      }

      // 3) Other routes: allow guest only if guest checkout is enabled and guest_id exists
      if (guest && configData?.guest_checkout_status === 1) {
        setChecked(true);
        return;
      }

      // 4) If config not loaded yet, be permissive (avoid blocking)
      if (!configData) {
        setChecked(true);
        return;
      }

      // 5) Otherwise, redirect to sign-in
      router.push(`/auth/sign-in?from=${from}`, undefined, { shallow: true });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [router.pathname, router.query?.page, from, configData?.guest_checkout_status]
  );

  if (!checked) {
    return null;
  }

  // If got here, it means that the redirect did not occur, and that tells us that the user is
  // authenticated / authorized.

  return <>{children}</>;
};

export default AuthGuard;
